import { ChangeDetectorRef, Pipe, PipeTransform, untracked } from '@angular/core';
import { FormControl } from '@angular/forms';

@Pipe({
  name: 'iohFilterTrainList'
})
export class IOHFilterTrainListPipe implements PipeTransform {
  constructor(private cd: ChangeDetectorRef) {}

  transform(
    count: number,
    formControl: FormControl,
    isCheckBoxControl = false,
    iohIsTrainIdSearch
  ): unknown {
    const isAlreadyDisabled = formControl.disabled;
    // if (count > 0) {
    //   formControl.enable();
    // } else {
    //   if (formControl instanceof FormControl) {
    //     formControl.disable();
    //   }
    // }
    // if (iohIsTrainIdSearch) {
    //   formControl.disable();
    // }
    untracked(() => {
      if (iohIsTrainIdSearch) {
        formControl.disable({ emitEvent: false });
      } else {
        formControl.enable({ emitEvent: false });
      }
    });
    const isDisabledNow = formControl.disabled;
    if (isAlreadyDisabled !== isDisabledNow) {
      this.cd.detectChanges();
    }
    return count;
  }
}
